export enum ScreenType {
  LED = 'LED',
  OLED = 'OLED',
  Plasma = 'Plasma',
  CCFL = 'CCFL',
  Unknown = 'Unknown'
}
